// 2026-09-03 — 등급 요약(useCreatorTierSummary) 조회 대상 판정을 한 곳에 모은다.
//
// 배경(실사고): 대표 계정 role 이 "Admin , Master , Creator , Copyrights Holder , Manager" 인데
// 상단바(TopNavBar)·내 정보(Settings)가 "Admin 또는 Copyrights Holder 가 들어 있으면 등급제 비대상"으로
// 판정해 조회를 건너뛰었다 — 채널 1개·등급 행 없음이라 정상이면 "루키 · 작품 영상 0/5" 배지가 떠야 했는데
// 아무것도 안 보였다. 홈(Home.jsx)은 게이트가 없어 카드가 뜨니 화면끼리도 어긋났다.
//
// 규칙: **Creator 가 들어 있으면 무조건 대상**. Creator 없이 Admin/Copyrights Holder/Platform 만 있으면
// 비대상(운영진·권리사·플랫폼사 — includeVariants 로 조회하면 행이 없어 "루키" 배지가 잘못 뜨므로 막는다).
// role 이 비어 있으면 대상(등급 행이 있는 role="" 계정이 실제로 있다 — 2026-09-02 DB 실측).
// 최종 판정은 어차피 데이터 유무로 다시 한다(summary=null 이면 아무것도 안 그린다).
const NON_CREATOR_ROLES = ["Admin", "Copyrights Holder", "Platform"];

export function isTierEligibleRole(role) {
  const r = typeof role === "string" ? role : "";
  if (r.includes("Creator")) return true;
  return !NON_CREATOR_ROLES.some((x) => r.includes(x));
}
